// Chatbot Screen Constants

// NOTE: Most use case routes are now dynamically generated via UseCaseContext with slug-based URLs
// However, some use cases have custom-built pages with special routes maintained below

// Custom routes for use cases with dedicated UIs (not template dashboards)
export const CUSTOM_USE_CASE_ROUTES = {
  "Content Supply Chain Management": "/authoring",
  "Pre-Call Summary": "/pre-call-summary",
  "On Call Intelligence": "/use-case/00002",
  "HNWI Observatory": "/uhnwi-observatory",
  "Financial Sentiment Analysis": "/financial-sentiment",
  "Fraud Claim Intake": "/customer-service"
};

// Role-based use case visibility
// Use cases not listed here are visible to all roles
export const USE_CASE_ROLE_RESTRICTIONS = {
  "Invest AI": ["advisor", "user"],  // Only advisors/investors, not admin
  "Portfolio Review": ["advisor", "user"],
  "HNWI Observatory": ["advisor", "user"],
  "Pre-Call Summary": ["advisor", "admin"],
  "On Call Intelligence": ["advisor", "admin"]
};

// Tool IDs
export const TOOL_IDS = { 
  RAG_AGENT: "00006"
};

// Service error messages
export const ERROR_MESSAGES = {
  MILVUS: "Milvus",
  DOCUMENT_PROCESSING: "I'm having trouble connecting to the document processing service. Let me try an alternative approach.",
  UPLOAD_FAILED: "Failed to upload files",
  QUOTA_EXCEEDED: "The service is currently unavailable due to high demand. Please try again later or contact support for assistance.",
  CONFIRMATION_ERROR: "Error processing your confirmation. Please try again.",
  SERVER_ERROR: "Error connecting to server. Please try again later.",
  CANCEL_MESSAGE: "Action cancelled. Is there something else I can help you with?"
};

// Action types for suggested actions
export const ACTION_TYPES = {
  SKIP_QUESTION: "skip_question",
  SELECT_DOMAIN: "select_domain",
  SELECT_VISUALIZATION: "select_visualization",
  SELECT_DATA_SOURCE: "select_data_source",
  SELECT_PURPOSE: "select_purpose",
  START_OVER: "start_over",
  PROVIDE_DETAILS: "provide_details",
  SUGGEST_CREATE: "suggest_create",
  BROWSE_USE_CASES: "browse_use_cases",
  UPLOAD_DOCUMENTS: "upload_documents",
  USE_AGENT: "use_agent",
  CREATE_VISUALIZATION: "create_visualization",
  CONFIGURE_AGENT: "configure_agent",
  CREATE_DASHBOARD: "create_dashboard",
  ANALYZE_DOCUMENTS: "analyze_documents",
  CREATE: "create",
  OPEN: "open"
};

// Status messages
export const STATUS_MESSAGES = {
  PROCESSING: "Processing your request...",
  UPLOADED_SINGLE: "Thank you for uploading this file.",
  UPLOADED_MULTIPLE: "Thank you for uploading these files.",
  START_OVER: "Let's start over. How can I help you today?",
  NEEDS_CLARIFICATION: "needs_clarification"
};

// Timing constants
export const TIMING = {
  ACTION_DELAY: 100
};

// ID Generation
export const COLLECTION_NAME_PREFIX = 'U';
export const ID_LENGTH = 5;
export const ID_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789';

// Helper function to generate short IDs
export const generateShortId = () => {
  let result = '';
  for (let i = 0; i < ID_LENGTH; i++) {
    result += ID_CHARS.charAt(Math.floor(Math.random() * ID_CHARS.length));
  }
  return result;
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  ADVISOR: 'advisor',
  USER: 'user'
};

